var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuarterNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9904 4H18.3988V19.9202C18.1781 19.6901 17.8918 19.507 17.5725 19.3897C17.1218 19.216 16.6242 19.1408 16.1312 19.1361C15.1359 19.1268 14.1547 19.4085 13.3143 19.8638C12.4739 20.3239 11.7744 21.0047 11.38 21.7934C10.9904 22.5634 10.8026 23.493 11.3002 24.23C11.8073 24.9577 12.8448 25.2441 13.8026 25.2676C14.7838 25.2958 15.7791 25.0376 16.6195 24.5822C17.4551 24.1221 18.1828 23.4695 18.6101 22.6807C18.8213 22.2911 18.9669 21.8638 18.995 21.4366C18.995 21.385 18.995 21.338 18.995 21.2864L19.0044 21.3052V4H18.9904Z",
    fill: "#4A4A4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuarterNote);
export default __webpack_public_path__ + "static/media/quarter-note.711e223aaea2b8ac7477c606ffcc1206.svg";
export { ForwardRef as ReactComponent };